import { render, staticRenderFns } from "./tree-node.vue?vue&type=template&id=5d24d17e&"
import script from "./tree-node.vue?vue&type=script&lang=js&"
export * from "./tree-node.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports